import theme from '../../theme';
import { instrumentTypeFilters } from '../../utils/helpers';

// Same pill chrome as the view-mode ToggleSwitch.
function InstrumentTypeFilter({ value, onChange }) {
  return (
    <div className="inline-block">
      <div className={`text-sm leading-none inline-flex p-1 ${theme.pillContainer}`}>
        {instrumentTypeFilters.map((filter) => (
          <button
            key={filter}
            onClick={() => onChange(filter)}
            className={`inline-flex items-center capitalize transition-all duration-200 rounded-lg px-4 py-2 text-sm font-medium ${value === filter ? theme.pillActive : theme.pillInactive
              }`}
          >
            {filter}
          </button>
        ))}
      </div>
    </div>
  );
}

export default InstrumentTypeFilter;
